import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import cn from "classnames";
import { tabsActions } from "./tabsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Tabs = ({ tabList }) => {
  const { pathname } = useLocation();
  const activeTab = useSelector((state) => state.tabs.activeTab);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const changeTabHandler = (tab) => {
    dispatch(tabsActions.changeTab(tab));
  };

  useEffect(() => {
    let path = pathname.slice(1);
    if (path === "") {
      dispatch(tabsActions.changeTab("HOME"));
    } else {
      dispatch(tabsActions.changeTab(path.toUpperCase()));
    }
  }, [pathname, activeTab, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeTab]);

  return (
    <div className="flex lg:gap-8 gap-2 md:gap-0 items-center">
      {tabList.map((tabName) => {
        const isCurrentPage = activeTab === tabName.toUpperCase();

        return (
          <Link
            key={tabName}
            className={cn(
              "relative whitespace-nowrap p-2 text-center font-semibold cursor-pointer transition-all duration-300",
              {
                "text-white border-baseGreen hover:text-baseGreen": !isCurrentPage,
                "text-baseGreen  border-transparent":
                  isCurrentPage,
              }
            )}
            onClick={() => changeTabHandler(tabName)}
            to={"/" + tabName.toLowerCase()}
          >
            {t(`${tabName}`)}
            {/* {isCurrentPage && (
              <div className="absolute bottom-0 left-0 w-full h-[2px] bg-baseBlue rounded-t"></div>
            )} */}
          </Link>
        );
      })}
    </div>
  );
};

export default Tabs;
